import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import { database } from '@/database';

import authModule, { reducer as authReducer } from '@/auth';
import games from '@/games/store';
import players from '@/players/store';

Vue.use(Vuex);

const persist = new VuexPersistence({
  reducer: state => ({
    auth: authReducer(state.auth),
  }),
  storage: window.sessionStorage,
});

export const initialState = () => ({ phrases: null });

export default new Vuex.Store({
  state: initialState(),
  mutations: {
    setPhrases(state, { phrases }) {
      Vue.set(state, 'phrases', phrases);
    },
  },
  actions: {
    async loadPhrases({ commit }) {
      const snapshot = await database.ref('/phrases').once('value');
      commit('setPhrases', { phrases: snapshot.val() });
    },
    async savePhrases({ commit }, phrases) {
      await database.ref('/phrases').set(phrases);
      commit('setPhrases', { phrases });
    },
  },
  modules: {
    auth: authModule,
    games,
    players,
  },
  getters: {},
  plugins: [persist.plugin],
});
